import { useEffect, useRef, useState } from 'react';

/**
 * Trails `value` by `delayMs`. Compared by encoded identity, so a fresh object each
 * render doesn't restart the timer. Returns `[settled, pending]`; the first value is
 * returned immediately.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): [T, boolean] {
    const [settled, setSettled] = useState(value);
    const key = JSON.stringify(value);
    const settledKey = useRef(key);

    useEffect(() => {
        if (settledKey.current === key) return;
        const t = setTimeout(() => {
            settledKey.current = key;
            setSettled(value);
        }, delayMs);
        return () => clearTimeout(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key, delayMs]);

    return [settled, settledKey.current !== key];
}
